import {
  Autocomplete,
  Button,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { clone, isEmpty, isNil } from "ramda";
import palette from "../../../../config/colorPalette";
import { ErrorText } from "../styled";
import { useMemo, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

const ChannelInfo = ({
  equipments,
  setEquipments,
  selectedEquipment,
  setSelectedEquipment,
  selectedEquipmentID,
  channel,
  indexChannel,
  equipmentInterMeasurement,
  setEquipmentInterMeasurement,
  channelDataToggle,
  setChannelDataToggle,
  zoneToggle,
  setZoneToggle,
  setRealState,
  assetSensors,
  channelsSensorsIDs,
  setchannelSensorsIDs,
  errors,
  setErrors,
  BootstrapButton,
  polylines,
  disabled,
  intl,
}) => {
  const [substructureAsignToggle, setSubstructureAsignToggle] = useState(false);
  const [substructureDataToggle, setSubstructureDataToggle] = useState([]);
  const [substructureSectionToggle, setSubstructureSectionToggle] = useState([]);
  const [substructureSectionDataToggle, setSubstructureSectionDataToggle] = useState([]);

  useMemo(() => {
    const actualLength = selectedEquipment.channels[indexChannel].substructures.length;

    const newSubAsign = [];
    const newSectionAsign = [];
    const newSectionDataAsign = [];
    for (let indexSub = 0; indexSub < actualLength; indexSub++) {
      if (isNil(substructureDataToggle[indexSub])) {
        newSubAsign.push(false);
      } else {
        newSubAsign.push(substructureDataToggle[indexSub]);
      }
      if (
        isNil(substructureSectionToggle[indexSub]) &&
        selectedEquipment.channels[indexChannel].substructures[indexSub].type === "inclinometer"
      ) {
        newSectionAsign.push(false);
      } else if (selectedEquipment.channels[indexChannel].substructures[indexSub].type === "inclinometer") {
        newSectionAsign.push(substructureSectionToggle[indexSub]);
      } else {
        newSectionAsign.push(null);
      }
      newSectionDataAsign.push([]);
      if (
        isNil(substructureSectionDataToggle[indexSub]) &&
        selectedEquipment.channels[indexChannel].substructures[indexSub].type === "inclinometer"
      ) {
        const secCount = selectedEquipment.channels[indexChannel].substructures[indexSub].sections?.length;
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          newSectionDataAsign[indexSub].push(false);
        }
      } else if (selectedEquipment.channels[indexChannel].substructures[indexSub].type === "inclinometer") {
        const secCount = selectedEquipment.channels[indexChannel].substructures[indexSub].sections.length;
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          if (isNil(substructureSectionDataToggle[indexSub][indexSection])) {
            newSectionDataAsign[indexSub].push(false);
          } else {
            newSectionDataAsign[indexSub].push(substructureSectionDataToggle[indexSub][indexSection]);
          }
        }
      } else {
        newSectionDataAsign.push(null);
      }
    }
    setSubstructureSectionDataToggle(newSectionDataAsign);
    setSubstructureSectionToggle(newSectionAsign);
    setSubstructureDataToggle(newSubAsign);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Dialog
      maxWidth="lg"
      open={channelDataToggle[indexChannel]}
      onClose={() => {
        let newChannel = clone(channelDataToggle);
        newChannel[indexChannel] = false;
        setChannelDataToggle(newChannel);
      }}
    >
      <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
        {selectedEquipment.channels[indexChannel].name} - {intl.formatMessage({ id: "channel" })} {indexChannel + 1}
      </DialogTitle>
      <DialogContent>
        <div style={{ marginTop: "1%" }}>
          <TextField
            id={`channel_name_${indexChannel}`}
            style={{ margin: "0 0.2rem 0.8rem" }}
            value={channel.name}
            onChange={(e) => {
              const indexEquipment = equipments.findIndex((equipment) => equipment.equipmentID === selectedEquipmentID);

              const newEquipments = [...equipments];
              const updatedEquipment = {
                ...newEquipments[indexEquipment],
                channels: [...newEquipments[indexEquipment].channels],
              };

              updatedEquipment.channels[indexChannel] = {
                ...updatedEquipment.channels[indexChannel],
                name: e.target.value,
              };

              newEquipments[indexEquipment] = updatedEquipment;
              setSelectedEquipment(updatedEquipment);
              setEquipments(newEquipments);
            }}
            error={errors[`channel_name_${indexChannel}`] ? true : false}
            variant="outlined"
            label={intl.formatMessage({ id: "channel.name" })}
            required
            disabled={disabled}
          ></TextField>
          <TextField
            id={`channel_length_${indexChannel}`}
            style={{ margin: "0 0.2rem 0.8rem" }}
            inputProps={{ min: Math.max(...selectedEquipment.channels.map((ch) => ch.info.length)) }}
            value={channel.info.length}
            error={errors[`channel_length_${indexChannel}`] ? true : false}
            variant="outlined"
            label={intl.formatMessage({ id: "channel.length" })}
            type="number"
            required
            disabled={disabled}
            InputLabelProps={{
              shrink: true,
            }}
          ></TextField>
          {selectedEquipment.equipmentType !== "DAS" && (
            <TextField
              id={`channel_spatial_resolution_${indexChannel}`}
              style={{ margin: "0 0.2rem 0.8rem" }}
              inputProps={{ min: 0 }}
              value={channel.info.spatialResolution}
              onChange={(e) => {
                const indexEquipment = equipments.findIndex(
                  (equipment) => equipment.equipmentID === selectedEquipmentID,
                );

                const newEquipments = [...equipments];
                const updatedEquipment = {
                  ...newEquipments[indexEquipment],
                  channels: [...newEquipments[indexEquipment].channels],
                };

                updatedEquipment.channels[indexChannel] = {
                  ...updatedEquipment.channels[indexChannel],
                  info: {
                    ...updatedEquipment.channels[indexChannel].info,
                    spatialResolution: parseFloat(e.target.value),
                  },
                };

                newEquipments[indexEquipment] = updatedEquipment;
                setSelectedEquipment(updatedEquipment);
                setEquipments(newEquipments);
              }}
              error={errors[`channel_spatial_resolution_${indexChannel}`] ? true : false}
              variant="outlined"
              label={intl.formatMessage({ id: "channel.spatial.resolution" })}
              required
              disabled={
                (selectedEquipment.manufacturer !== "Uptech Sensing" &&
                  selectedEquipment.manufacturer !== "AP Sensing") ||
                disabled
              }
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
            ></TextField>
          )}
          <TextField
            id={`channel_sampling_interval_${indexChannel}`}
            style={{ margin: "0 0.2rem 0.8rem" }}
            inputProps={{ min: 0 }}
            value={channel.info.samplingInterval}
            disabled={true}
            error={errors[`channel_sampling_interval_${indexChannel}`] ? true : false}
            variant="outlined"
            label={intl.formatMessage({ id: "channel.sampling.interval" })}
            required
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
          ></TextField>
          {selectedEquipment.equipmentType !== "DAS" && (
            <>
              <TextField
                id={`channel_measurement_time_${indexChannel}`}
                style={{ margin: "0 0.2rem 0.8rem" }}
                inputProps={{ min: 0 }}
                value={channel.measurement.measurementTime}
                onChange={(e) => {
                  const indexEquipment = equipments.findIndex(
                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                  );

                  const newEquipments = [...equipments];
                  const updatedEquipment = {
                    ...newEquipments[indexEquipment],
                    channels: [...newEquipments[indexEquipment].channels],
                  };

                  updatedEquipment.channels[indexChannel] = {
                    ...updatedEquipment.channels[indexChannel],
                    measurement: {
                      ...updatedEquipment.channels[indexChannel].measurement,
                      measurementTime: parseFloat(e.target.value),
                    },
                  };
                  const newErrors = { ...errors };
                  const actualID = selectedEquipmentID + "_frequency";
                  let newSuma = 0;

                  const falseStateChannels = updatedEquipment.channels.reduce((indices, valor, indice) => {
                    if (!valor.state) {
                      indices.push(indice);
                    }
                    return indices;
                  }, []);
                  let auxEquipmentInterMeasurement = equipmentInterMeasurement;
                  for (let indexState = 0; indexState < falseStateChannels.length; indexState++) {
                    if (
                      !isNil(updatedEquipment.channels[falseStateChannels[indexState]].measurement) &&
                      !isNil(updatedEquipment.channels[falseStateChannels[indexState]].measurement.measurementTime)
                    ) {
                      auxEquipmentInterMeasurement =
                        auxEquipmentInterMeasurement -
                        updatedEquipment.channels[falseStateChannels[indexState]].measurement.measurementTime;
                    }
                  }
                  if (
                    isEmpty(updatedEquipment.channels[indexChannel].measurement.measurementInfo) ||
                    isNaN(updatedEquipment.channels[indexChannel].measurement.measurementInfo)
                  ) {
                    newErrors[e.target.id] = "not.empty";
                  } else if (parseFloat(equipmentInterMeasurement) < newSuma) {
                    newErrors[actualID] = "not.higher.than.amount.measurement.time.channels";
                  } else if (parseFloat(equipmentInterMeasurement) > 86400) {
                    newErrors[e.target.id] = "not.higher.than.day";
                  } else {
                    delete newErrors[actualID];
                    delete newErrors[e.target.id];
                  }
                  setErrors(newErrors);
                  newEquipments[indexEquipment] = updatedEquipment;
                  setSelectedEquipment(updatedEquipment);
                  setEquipments(newEquipments);
                  setEquipmentInterMeasurement(auxEquipmentInterMeasurement);
                }}
                error={errors[`channel_measurement_time_${indexChannel}`] ? true : false}
                variant="outlined"
                label={intl.formatMessage({ id: "channel.measurement.time" })}
                required
                disabled={
                  (selectedEquipment.moreInfo.manufacturer !== "Uptech Sensing" &&
                    selectedEquipment.moreInfo.manufacturer !== "AP Sensing") ||
                  disabled
                }
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
              ></TextField>
              {!isNil(errors[`channel_measurement_time_${indexChannel}`]) && (
                <ErrorText>
                  {intl.formatMessage({
                    id: errors[`channel_measurement_time_${indexChannel}`],
                  })}
                </ErrorText>
              )}
            </>
          )}

          {selectedEquipment.equipmentType === "DAS" && (
            <>
              <TextField
                id={`channel_acquisition_frequency_${indexChannel}`}
                style={{ margin: "0 0.2rem 0.8rem" }}
                defaultValue={0}
                inputProps={{
                  min: 0,
                  max:
                    selectedEquipment.type === "DOUBLE"
                      ? (parseInt(Math.ceil(1 / (2 * (channel.info.length * 1e-8)))) * 0.95) / 2
                      : parseInt(Math.ceil(1 / (2 * (channel.info.length * 1e-8)))) * 0.95,
                }}
                onChange={(e) => {
                  const indexEquipment = equipments.findIndex(
                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                  );

                  const newEquipments = [...equipments];
                  const updatedEquipment = {
                    ...newEquipments[indexEquipment],
                    channels: [...newEquipments[indexEquipment].channels],
                  };

                  updatedEquipment.channels[indexChannel] = {
                    ...updatedEquipment.channels[indexChannel],
                    info: {
                      ...updatedEquipment.channels[indexChannel].info,
                      acquisitionFrequency: parseFloat(e.target.value),
                    },
                  };

                  newEquipments[indexEquipment] = updatedEquipment;
                  setSelectedEquipment(updatedEquipment);
                  setEquipments(newEquipments);
                }}
                error={errors[`channel_acquisition_frequency_${indexChannel}`] ? true : false}
                variant="outlined"
                disabled={disabled}
                label={intl.formatMessage({ id: "channel.acquisition.frequency" })}
                required
                type="number"
              ></TextField>{" "}
              <TextField
                id={`channel_gauge_length_${indexChannel}`}
                style={{ margin: "0 0.2rem 0.8rem" }}
                defaultValue={0}
                inputProps={{ min: 0 }}
                disabled={disabled}
                onChange={(e) => {
                  const indexEquipment = equipments.findIndex(
                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                  );

                  const newEquipments = [...equipments];
                  const updatedEquipment = {
                    ...newEquipments[indexEquipment],
                    channels: [...newEquipments[indexEquipment].channels],
                  };

                  updatedEquipment.channels[indexChannel] = {
                    ...updatedEquipment.channels[indexChannel],
                    info: {
                      ...updatedEquipment.channels[indexChannel].info,
                      gaugeLength: parseFloat(e.target.value),
                    },
                  };

                  newEquipments[indexEquipment] = updatedEquipment;
                  setSelectedEquipment(updatedEquipment);
                  setEquipments(newEquipments);
                }}
                error={errors[`channel_gauge_length_${indexChannel}`] ? true : false}
                variant="outlined"
                label={intl.formatMessage({ id: "channel.gauge.length" })}
                required
                type="number"
              ></TextField>
            </>
          )}
          <FormControlLabel
            control={
              <Checkbox
                id={"checkbox" + indexChannel}
                sx={{
                  color: palette.primary,
                  "&.Mui-checked": {
                    color: palette.primary,
                  },
                }}
                checked={!channel.state}
                onChange={(e) => {
                  const indexEquipment = equipments.findIndex(
                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                  );

                  const newEquipments = [...equipments];
                  const updatedEquipment = {
                    ...newEquipments[indexEquipment],
                    channels: [...newEquipments[indexEquipment].channels],
                  };

                  updatedEquipment.channels[indexChannel] = {
                    ...updatedEquipment.channels[indexChannel],
                    state: !e.target.checked,
                  };
                  newEquipments[indexEquipment] = updatedEquipment;

                  setRealState(false);
                  setSelectedEquipment(updatedEquipment);
                  setEquipments(newEquipments);
                }}
                disabled={disabled}
              />
            }
            label={intl.formatMessage({ id: "disable?" })}
            style={{ marginLeft: "auto" }}
          />
          {!channel.state ? (
            <TextField
              id={`channel_info_${indexChannel}`}
              style={{ margin: "0 0.2rem 0.8rem" }}
              inputProps={{ min: 0 }}
              value={channel.info.desc}
              onChange={(e) => {
                const indexEquipment = equipments.findIndex(
                  (equipment) => equipment.equipmentID === selectedEquipmentID,
                );

                const newEquipments = [...equipments];
                const updatedEquipment = {
                  ...newEquipments[indexEquipment],
                  channels: [...newEquipments[indexEquipment].channels],
                };

                updatedEquipment.channels[indexChannel] = {
                  ...updatedEquipment.channels[indexChannel],
                  info: {
                    ...updatedEquipment.channels[indexChannel].info,
                    desc: e.target.value,
                  },
                };

                newEquipments[indexEquipment] = updatedEquipment;
                setSelectedEquipment(updatedEquipment);
                setEquipments(newEquipments);
              }}
              disabled={disabled}
              error={errors[`channel_info_${indexChannel}`] ? true : false}
              variant="outlined"
              label={intl.formatMessage({ id: "channel.info" })}
            />
          ) : null}
        </div>
        <div>
          <TextField
            id={`sub_quantity${indexChannel}`}
            style={{ margin: "0 0.2rem 0.8rem", width: "150px", minWidth: 0 }}
            defaultValue={selectedEquipment.channels[indexChannel].substructures.length}
            value={selectedEquipment.channels[indexChannel].substructures.length}
            inputProps={{ min: 0 }}
            onChange={(ev) => {
              const indexEquipment = equipments.findIndex((equipment) => equipment.equipmentID === selectedEquipmentID);
              const newEquipments = [...equipments];
              const updatedEquipment = {
                ...newEquipments[indexEquipment],
                channels: newEquipments[indexEquipment].channels.map((channel) => ({
                  ...channel,
                  substructures: [...channel.substructures], // Clonar el array
                })),
              };
              const newLength = parseInt(ev.target.value);
              const actualLength = updatedEquipment.channels[indexChannel].substructures.length;
              if (newLength > actualLength) {
                for (let i = actualLength; i < newLength; i++) {
                  if (!isEmpty(polylines)) {
                    updatedEquipment.channels[indexChannel].substructures.push({
                      name: "",
                      type: "generic",
                      polyline: 0,
                      depth: null,
                      sections: null,
                      zones: [],
                      ref: "",
                      equipmentBehavior: updatedEquipment[indexEquipment].equipmentType === "A-DTS" ? "A-DTS" : null,
                    });
                  } else {
                    updatedEquipment.channels[indexChannel].substructures.push({
                      name: "",
                      type: "inclinometer",
                      polyline: [0, 0],
                      depth: 50,
                      sections: [""],
                      zones: [],
                      ref: "",
                      equipmentBehavior: updatedEquipment[indexEquipment].equipmentType === "A-DTS" ? "A-DTS" : null,
                    });
                  }
                }
              } else {
                updatedEquipment.channels[indexChannel].substructures.splice(newLength);
              }
              newEquipments[indexEquipment] = updatedEquipment;
              setSelectedEquipment(updatedEquipment);
              setEquipments(newEquipments);
            }}
            error={errors[`channel_acquisition_frequency_${indexChannel}`] ? true : false}
            variant="outlined"
            label={intl.formatMessage({ id: "sub.count" })}
            required
            disabled={disabled}
            type="number"
          />
          {selectedEquipment.channels[indexChannel].substructures.length > 0 && (
            <BootstrapButton
              variant="contained"
              style={{ margin: "0.5rem 0.2rem 0.8rem" }}
              id="substructures-to-channels"
              onClick={() => {
                let newChannel = clone(substructureAsignToggle);
                if (newChannel) {
                  newChannel = false;
                } else {
                  newChannel = true;
                }
                setSubstructureAsignToggle(newChannel);
              }}
            >
              {intl.formatMessage({ id: "substructures.to.polylines" })}
              {!substructureAsignToggle ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
            </BootstrapButton>
          )}

          <Collapse in={substructureAsignToggle}>
            {selectedEquipment.channels[indexChannel].substructures.map((sub, indSub) => {
              return (
                <>
                  <h1
                    style={{ marginRight: "1%" }}
                    id={`sub${indSub}_collapse`}
                    onClick={() => {
                      let newChannel = clone(substructureDataToggle);
                      if (newChannel[indSub]) {
                        newChannel[indSub] = false;
                      } else {
                        newChannel[indSub] = true;
                      }
                      setSubstructureDataToggle(newChannel);
                    }}
                  >
                    {intl.formatMessage({ id: "sub" })} {indSub + 1}
                    {!substructureDataToggle[indSub] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                  </h1>
                  <Collapse in={substructureDataToggle[indSub]}>
                    <div
                      key={`substructure_${indSub}`}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "0.5rem",
                        width: "100%",
                        marginTop: "2%",
                        boxSizing: "border-box",
                      }}
                    >
                      <TextField
                        id={`sub_name_${indSub}`}
                        style={{ width: "15rem", minWidth: 0 }}
                        defaultValue={selectedEquipment.channels[indexChannel].substructures[indSub].name}
                        value={selectedEquipment.channels[indexChannel].substructures[indSub].name}
                        disabled={true}
                        onChange={(ev) => {
                          const indexEquipment = equipments.findIndex(
                            (equipment) => equipment.equipmentID === selectedEquipmentID,
                          );
                          const newEquipments = [...equipments];
                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                          updatedEquipment.channels[indexChannel].substructures[indSub].name = ev.target.value;
                          newEquipments[indexEquipment] = updatedEquipment;
                          setSelectedEquipment(updatedEquipment);
                          setEquipments(newEquipments);
                        }}
                        error={errors[`sub_name_${indSub}`] ? true : false}
                        variant="outlined"
                        label={intl.formatMessage({ id: "sub.name" })}
                        required
                      />

                      <TextField
                        id={`sub_type_${indSub}`}
                        variant="outlined"
                        style={{ width: "15rem", minWidth: 0 }}
                        label={intl.formatMessage({ id: "sub.type" })}
                        value={selectedEquipment.channels[indexChannel].substructures[indSub].type}
                        select
                        onChange={(ev) => {
                          const indexEquipment = equipments.findIndex(
                            (equipment) => equipment.equipmentID === selectedEquipmentID,
                          );

                          const newEquipments = [...equipments];

                          const updatedEquipment = {
                            ...newEquipments[indexEquipment],
                            channels: [...newEquipments[indexEquipment].channels],
                          };

                          updatedEquipment.channels[indexChannel] = {
                            ...updatedEquipment.channels[indexChannel],
                            substructures: [...updatedEquipment.channels[indexChannel].substructures],
                          };

                          updatedEquipment.channels[indexChannel].substructures[indSub] = {
                            ...updatedEquipment.channels[indexChannel].substructures[indSub],
                          };

                          const substructure = updatedEquipment.channels[indexChannel].substructures[indSub];
                          substructure.type = ev.target.value;
                          const polyNumber = substructure.polyline;
                          if (ev.target.value === "generic" && !Number.isInteger(polyNumber)) {
                            updatedEquipment.channels[indexChannel].substructures[indSub].polyline = 0;
                            updatedEquipment.channels[indexChannel].substructures[indSub].depth = null;
                            updatedEquipment.channels[indexChannel].substructures[indSub].sections = null;
                          } else if (ev.target.value === "inclinometer" && Number.isInteger(polyNumber)) {
                            updatedEquipment.channels[indexChannel].substructures[indSub].polyline = [0, 0];
                            updatedEquipment.channels[indexChannel].substructures[indSub].depth = 50;
                            updatedEquipment.channels[indexChannel].substructures[indSub].sections = [""];
                            let newSectionDataToggle = [];

                            for (
                              let indexSub = 0;
                              indexSub < updatedEquipment.channels[indexChannel].substructures.length;
                              indexSub++
                            ) {
                              newSectionDataToggle.push([]);
                              for (
                                let indexSection = 0;
                                indexSection <
                                updatedEquipment.channels[indexChannel].substructures[indexSub].sections.length;
                                indexSection++
                              ) {
                                if (
                                  isNil(substructureSectionDataToggle[indexSub]) ||
                                  isNil(substructureSectionDataToggle[indexSub][indexSection])
                                ) {
                                  newSectionDataToggle[indexSub].push(false);
                                } else {
                                  newSectionDataToggle[indexSub].push(
                                    substructureSectionDataToggle[indexSub][indexSection],
                                  );
                                }
                              }
                            }
                            setSubstructureSectionDataToggle(newSectionDataToggle);
                          }
                          newEquipments[indexEquipment] = updatedEquipment;
                          setSelectedEquipment(updatedEquipment);

                          setEquipments(newEquipments);
                        }}
                        disabled={disabled}
                        error={errors[`sub_type_${indSub}`] ? true : false}
                        required
                      >
                        {!isEmpty(polylines) && (
                          <MenuItem key={`sub_type_${indSub}_generic`} value={"generic"}>
                            Generic
                          </MenuItem>
                        )}
                        <MenuItem key={`sub_type_${indSub}_inclinometer`} value={"inclinometer"}>
                          Inclinometer
                        </MenuItem>
                      </TextField>
                      {selectedEquipment.equipmentType === "A-DTS" && (
                        <TextField
                          id={`sub_behavior_${indSub}`}
                          variant="outlined"
                          //disabled={!moreSubsAllowed}
                          style={{ width: "5rem", minWidth: 0 }}
                          label={intl.formatMessage({ id: "sub.behavior" })}
                          value={selectedEquipment.channels[indexChannel].substructures[indSub].equipmentBehavior}
                          select
                          disabled={disabled}
                          onChange={(ev) => {
                            const indexEquipment = equipments.findIndex(
                              (equipment) => equipment.equipmentID === selectedEquipmentID,
                            );
                            const newEquipments = [...equipments];
                            const updatedEquipment = { ...newEquipments[indexEquipment] };
                            updatedEquipment.channels[indexChannel].substructures[indSub].equipmentBehavior =
                              ev.target.value;
                            newEquipments[indexEquipment] = updatedEquipment;
                            setSelectedEquipment(updatedEquipment);

                            setEquipments(newEquipments);
                          }}
                          required
                        >
                          <MenuItem key={`sub_behavior_${indSub}_A-DTS"`} value={"A-DTS"}>
                            A-DTS
                          </MenuItem>

                          <MenuItem key={`sub_behavior_${indSub}_DTSS`} value={"DTS"}>
                            DTSS
                          </MenuItem>
                        </TextField>
                      )}

                      {selectedEquipment.channels[indexChannel].substructures[indSub].type === "inclinometer" && (
                        <TextField
                          id={`sub_sectioncount_${indSub}`}
                          style={{ width: "12rem", minWidth: 0 }}
                          defaultValue={
                            !isNil(selectedEquipment.channels[indexChannel].substructures[indSub].sections)
                              ? selectedEquipment.channels[indexChannel].substructures[indSub].sections.length
                              : 0
                          }
                          inputProps={{ min: 1 }}
                          onChange={(ev) => {
                            const indexEquipment = equipments.findIndex(
                              (equipment) => equipment.equipmentID === selectedEquipmentID,
                            );
                            const newEquipments = [...equipments];
                            const updatedEquipment = { ...newEquipments[indexEquipment] };
                            const newSection = [];
                            let newSectionDataToggle = [];
                            for (let indexSection = 0; indexSection < parseInt(ev.target.value); indexSection++) {
                              if (
                                isNil(updatedEquipment.channels[indexChannel].substructures[indSub].depth[indexSection])
                              ) {
                                newSection.push("");
                              } else {
                                newSection.push(
                                  updatedEquipment.channels[indexChannel].substructures[indSub].sections[indexSection],
                                );
                              }
                            }

                            for (let indexSub = 0; indexSub < channel.substructures.length; indexSub++) {
                              newSectionDataToggle.push([]);
                              for (
                                let indexSection = 0;
                                indexSection < channel.substructures[indexSub].sections.length;
                                indexSection++
                              ) {
                                if (
                                  isNil(substructureSectionDataToggle[indexSub]) ||
                                  isNil(substructureSectionDataToggle[indexSub][indexSection])
                                ) {
                                  newSectionDataToggle[indexSub].push(false);
                                } else {
                                  newSectionDataToggle[indexSub].push(
                                    substructureSectionDataToggle[indexSub][indexSection],
                                  );
                                }
                              }
                            }

                            const updatedChannels = [...updatedEquipment.channels];
                            const updatedChannel = { ...updatedChannels[indexChannel] };

                            const updatedSubstructures = [...updatedChannel.substructures];
                            const updatedSub = {
                              ...updatedSubstructures[indSub],
                              sections: newSection, // <-- aquí colocas newSections exactamente
                            };

                            updatedSubstructures[indSub] = updatedSub;

                            const updatedChannelFixed = { ...updatedChannel, substructures: updatedSubstructures };

                            updatedChannels[indexChannel] = updatedChannelFixed;

                            updatedEquipment.channels = updatedChannels;
                            newEquipments[indexEquipment] = updatedEquipment;

                            newEquipments[indexEquipment] = updatedEquipment;
                            setSubstructureSectionDataToggle(newSectionDataToggle);
                            setSelectedEquipment(updatedEquipment);
                            setEquipments(newEquipments);
                          }}
                          disabled={disabled}
                          type="number"
                          error={errors[`sub_sectioncount_${indSub}`] ? true : false}
                          variant="outlined"
                          label={intl.formatMessage({ id: "sub.section" })}
                          required
                        />
                      )}

                      {/* Polyline select OR lat/lon inputs */}
                      {selectedEquipment.channels[indexChannel].substructures[indSub].type === "generic" ? (
                        <>
                          <Select
                            id={selectedEquipment.equipmentID + "channel" + indexChannel + "_poly"}
                            label={intl.formatMessage({ id: "polyline" })}
                            onChange={(ev) => {
                              const indexEquipment = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );

                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[indexEquipment] };
                              updatedEquipment.channels[indexChannel].substructures[indSub].polyline = parseInt(
                                ev.target.value,
                              );
                              newEquipments[indexEquipment] = updatedEquipment;
                              //setHoveredPolylineIndex(null);
                              setSelectedEquipment(updatedEquipment);

                              setEquipments(newEquipments);
                            }}
                            disabled={disabled}
                            defaultValue={selectedEquipment.channels[indexChannel].substructures[indSub].polyline}
                            onMouseOut={() => {
                              //setHoveredPolylineIndex(null);
                            }}
                            style={{ width: "6rem", minWidth: 0 }}
                          >
                            {polylines.map((p, indPoly) => {
                              if (p.equipment_type === "DAS") return null;
                              return (
                                <MenuItem
                                  key={selectedEquipment.equipmentID + "channel" + indexChannel + "_" + indPoly}
                                  value={indPoly}
                                >
                                  {p.id}
                                </MenuItem>
                              );
                            })}
                          </Select>
                          <TextField
                            id={selectedEquipment.equipmentID + "channel" + indexChannel + "_length"}
                            style={{ width: "5.5rem", minWidth: 0 }}
                            inputProps={{ min: 0 }}
                            defaultValue={selectedEquipment.channels[indexChannel].substructures[indSub].subLength}
                            onBlur={(ev) => {
                              const value = parseFloat(ev.target.value);
                              const newErrors = { ...errors };
                              if (isEmpty(ev.target.value) || isNaN(value)) {
                                newErrors[ev.target.id] = "not.empty";
                              } else if (value < 0) {
                                newErrors[ev.target.id] = "min.value.surpassed";
                              } else {
                                delete newErrors[ev.target.id];
                              }
                              const indexEquipment = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );
                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[indexEquipment] };
                              if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                                updatedEquipment.channels[indexChannel].substructures[indSub].subLength = parseFloat(
                                  ev.target.value,
                                );
                                if (updatedEquipment) {
                                  const id = `channel${indexChannel}_length`;

                                  const newLength = updatedEquipment.channels[indexChannel]?.substructures.reduce(
                                    (sum, sub) => sum + (sub?.subLength ?? 0),
                                    0,
                                  );

                                  if (newLength > selectedEquipment.channels[indexChannel].info.length) {
                                    newErrors[id] = "max.value.surpassed";
                                  } else {
                                    delete newErrors[ev.target.id];
                                    delete newErrors[id];
                                  }
                                }
                              }
                              setErrors(newErrors);
                              newEquipments[indexEquipment] = updatedEquipment;
                              setSelectedEquipment(updatedEquipment);
                              setEquipments(newEquipments);
                            }}
                            variant="outlined"
                            label={intl.formatMessage({ id: "channel.length" })}
                            required
                            error={errors[`channel${indexChannel}section_subLength_${indSub}`] ? true : false}
                            type="number"
                          />
                        </>
                      ) : (
                        <div style={{ display: "flex", gap: "0.5rem" }}>
                          <TextField
                            id={`section_depth_${indexChannel}_${indSub}`}
                            style={{ width: "6.5rem", minWidth: 0 }}
                            inputProps={{ min: 0 }}
                            defaultValue={0}
                            value={selectedEquipment.channels[indexChannel].substructures[indSub].depth}
                            disabled={disabled}
                            onChange={(ev) => {
                              const indexEquipment = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );
                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[indexEquipment] };
                              if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                                updatedEquipment.channels[indexChannel].substructures[indSub].depth = parseFloat(
                                  ev.target.value,
                                );
                              }
                              newEquipments[indexEquipment] = updatedEquipment;
                              setSelectedEquipment(updatedEquipment);
                              setEquipments(newEquipments);
                            }}
                            variant="outlined"
                            label={intl.formatMessage({ id: "depth" })}
                            required
                            type="number"
                          />
                          <TextField
                            id={`sub_lat_${indSub}`}
                            style={{ width: "7.5rem", minWidth: 0 }}
                            defaultValue={selectedEquipment.channels[indexChannel].substructures[indSub].polyline[0]}
                            inputProps={{ min: -180, max: 180 }}
                            disabled={disabled}
                            onChange={(ev) => {
                              const indexEquipment = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );

                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[indexEquipment] };
                              if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                                updatedEquipment.channels[indexChannel].substructures[indSub].polyline[0] = parseFloat(
                                  ev.target.value,
                                );
                              }
                              newEquipments[indexEquipment] = updatedEquipment;
                              setSelectedEquipment(updatedEquipment);

                              setEquipments(newEquipments);
                            }}
                            type="number"
                            error={errors[`sub_lat_${indSub}`] ? true : false}
                            variant="outlined"
                            label={intl.formatMessage({ id: "latitude" })}
                            required
                          />
                          <TextField
                            id={`sub_lon_${indSub}`}
                            style={{ width: "7.5rem", minWidth: 0 }}
                            defaultValue={selectedEquipment.channels[indexChannel].substructures[indSub].polyline[1]}
                            inputProps={{ min: -180, max: 180 }}
                            disabled={disabled}
                            onChange={(ev) => {
                              const indexEquipment = equipments.findIndex(
                                (equipment) => equipment.equipmentID === selectedEquipmentID,
                              );

                              const newEquipments = [...equipments];
                              const updatedEquipment = { ...newEquipments[indexEquipment] };
                              if (!Number.isNaN(parseFloat(ev.target.value)) && !isNil(ev.target.value)) {
                                updatedEquipment.channels[indexChannel].substructures[indSub].polyline[1] = parseFloat(
                                  ev.target.value,
                                );
                              }
                              newEquipments[indexEquipment] = updatedEquipment;
                              setSelectedEquipment(updatedEquipment);
                              setEquipments(newEquipments);
                            }}
                            type="number"
                            error={errors[`sub_lon_${indSub}`] ? true : false}
                            variant="outlined"
                            label={intl.formatMessage({ id: "longitude" })}
                            required
                          />
                        </div>
                      )}
                    </div>
                    {selectedEquipment.channels[indexChannel].substructures[indSub].type === "inclinometer" && (
                      <BootstrapButton
                        variant="contained"
                        style={{ margin: "0.5rem 0.2rem 0.8rem" }}
                        id="substructures-to-channels"
                        onClick={() => {
                          let newSection = clone(substructureSectionToggle);
                          if (newSection[indSub]) {
                            newSection[indSub] = false;
                          } else {
                            newSection[indSub] = true;
                          }
                          setSubstructureSectionToggle(newSection);
                        }}
                      >
                        {intl.formatMessage({ id: "sections" })}
                        {!substructureSectionToggle[indSub] ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
                      </BootstrapButton>
                    )}
                    <Collapse in={substructureSectionToggle[indSub]}>
                      {selectedEquipment.channels[indexChannel].substructures[indSub].type === "inclinometer" &&
                        !isNil(substructureSectionToggle[indSub]) &&
                        selectedEquipment.channels[indexChannel].substructures[indSub].sections.map(
                          (section, indexSection) => {
                            return (
                              <>
                                <Button
                                  variant="contained"
                                  style={{ margin: "1%", backgroundColor: palette.secondary, color: "white" }}
                                  id={`collapseSub${indSub}_${indexSection}`}
                                  onClick={() => {
                                    let newA = clone(substructureSectionDataToggle);
                                    newA[indSub][indexSection] = true;
                                    setSubstructureSectionDataToggle(newA);
                                  }}
                                >
                                  {intl.formatMessage({ id: "section" })} {indexSection + 1}
                                </Button>
                                <Dialog
                                  maxWidth="lg"
                                  open={substructureSectionDataToggle[indSub][indexSection]}
                                  onClose={() => {
                                    let newA = clone(substructureSectionDataToggle);
                                    newA[indSub][indexSection] = false;
                                    setSubstructureSectionDataToggle(newA);
                                  }}
                                >
                                  <DialogTitle>
                                    {intl.formatMessage({ id: "section" })} {indexSection + 1}
                                  </DialogTitle>
                                  <DialogContent>
                                    <div style={{ marginTop: "2%" }}>
                                      <TextField
                                        id={`section_name_${indexChannel}_${indSub}_${indexSection}`}
                                        style={{ margin: "0 0.2rem 0.8rem", minWidth: 0, flex: "1 1 220px" }}
                                        defaultValue={""}
                                        value={
                                          selectedEquipment.channels[indexChannel].substructures[indSub].sections[
                                            indexSection
                                          ]
                                        }
                                        disabled={disabled}
                                        onChange={(ev) => {
                                          const indexEquipment = equipments.findIndex(
                                            (equipment) => equipment.equipmentID === selectedEquipmentID,
                                          );
                                          const newEquipments = [...equipments];
                                          const updatedEquipment = { ...newEquipments[indexEquipment] };
                                          updatedEquipment.channels[indexChannel].substructures[indSub].sections[
                                            indexSection
                                          ] = ev.target.value;
                                          newEquipments[indexEquipment] = updatedEquipment;
                                          setEquipments(newEquipments);
                                        }}
                                        variant="outlined"
                                        label={intl.formatMessage({ id: "section.name" })}
                                        required
                                      />
                                    </div>
                                  </DialogContent>
                                  <DialogActions>
                                    <Button
                                      variant="contained"
                                      style={{ backgroundColor: palette.secondary, color: "white" }}
                                      onClick={() => {
                                        let newA = clone(substructureSectionDataToggle);
                                        newA[indSub][indexSection] = false;
                                        setSubstructureSectionDataToggle(newA);
                                      }}
                                    >
                                      {intl.formatMessage({ id: "accept" })}
                                    </Button>
                                  </DialogActions>
                                </Dialog>
                              </>
                            );
                          },
                        )}
                    </Collapse>
                    {!isNil(assetSensors) && !isEmpty(assetSensors) && (
                      <Autocomplete
                        multiple
                        id="multiple-checkboxes"
                        options={assetSensors}
                        sx={{ width: "65rem", marginBottom: "1%", marginTop: "1%" }}
                        disableCloseOnSelect
                        disabled={disabled}
                        onChange={(event, values) => {
                          let auxSensors = clone(channelsSensorsIDs);
                          auxSensors[indexChannel][indSub] = values;
                          setchannelSensorsIDs(auxSensors);
                          const indexEquipment = equipments.findIndex(
                            (equipment) => equipment.equipmentID === selectedEquipmentID,
                          );

                          const newEquipments = [...equipments];

                          const updatedEquipment = {
                            ...newEquipments[indexEquipment],
                            channels: [...newEquipments[indexEquipment].channels],
                          };

                          const updatedChannel = {
                            ...updatedEquipment.channels[indexChannel],
                            substructures: [...updatedEquipment.channels[indexChannel].substructures],
                          };

                          updatedChannel.substructures[indSub] = {
                            ...updatedChannel.substructures[indSub],
                            sensors: auxSensors[indexChannel][indSub],
                          };
                          updatedEquipment.channels[indexChannel] = updatedChannel;
                          newEquipments[indexEquipment] = updatedEquipment;
                          setSelectedEquipment(updatedEquipment);
                          setEquipments(newEquipments);
                        }}
                        getOptionLabel={(option) => option}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox style={{ marginRight: 8 }} checked={selected} />
                            {intl.formatMessage({ id: option })}
                          </li>
                        )}
                        value={
                          isNil(channelsSensorsIDs[indexChannel][indSub])
                            ? []
                            : channelsSensorsIDs[indexChannel][indSub]
                        }
                        renderInput={(params) => (
                          <TextField {...params} variant="outlined" label={intl.formatMessage({ id: "sensor.ids" })} />
                        )}
                      />
                    )}
                  </Collapse>
                </>
              );
            })}
          </Collapse>
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          style={{ backgroundColor: palette.secondary, color: "white" }}
          onClick={() => {
            let newChannel = clone(channelDataToggle);
            newChannel[indexChannel] = false;
            setChannelDataToggle(newChannel);
          }}
        >
          {intl.formatMessage({ id: "accept" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChannelInfo;
